import { ISupplier } from "@drone-parts.garphild.pro/interfaces";
import { makeAutoObservable } from "mobx";
import RestApiQuery from "../helpers/rest-api-query";
import { notification } from "antd";

class SuppliersStorage {
  suppliers: ISupplier[] = [];
  constructor() {
    makeAutoObservable(this);
  }

  loadSuppliers = async () => {
    try {
      const data = await RestApiQuery.get<ISupplier[]>('/api/supplier');
      if (!data) {
        throw new Error('Suppliers loading failed');
      }
      this.suppliers = data;
      notification.success({ message: 'Suppliers loaded' });
    } catch (error) {
      notification.error({ message: 'Suppliers loading failed' });
    }
  }

  createSupplier = async (supplier: ISupplier) => {
    try {
      const data = await RestApiQuery.post<any, { data: ISupplier}>('/api/supplier', supplier)
      if (!data || !data.data) {
        throw new Error('Supplier creation failed');
      }
      this.suppliers.push(data.data);
      notification.success({ message: 'Supplier created' });
    } catch (error) {
      notification.error({ message: 'Supplier creation failed' });
    }
  }
}

const suppliersStorage = new SuppliersStorage();

export default suppliersStorage;
